import { ca } from '@cian/analytics';

export const trackUnarchivedButtonClick = (opponentId?: number) => {
  ca('eventSite', {
    action: 'restore_message_from_archive',
    category: 'Chat',
    label: '',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
};
